// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Une feuille a deux cases cochees : les taches. Source tasks.
 *
 * Fournie par le fondateur le 08/10/2026,
 * exportee en traces Potrace : cadre `0 0 240 240`, traces en dixiemes et
 * retournes (`translate(0 240) scale(.1 -.1)`), recopies tels quels.
 */
export const IconTasks = createCustomIcon(
  'IconTasks',
  '0 0 240 240',
  <>
    <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M200 1200 l0 -1200 1000 0 1000 0 0 913 0 912 -288 288 -287 287 -713 0 -712 0 0 -1200z m1537 738 l213 -213 0 -737 0 -738 -750 0 -750 0 0 950 0 950 537 0 538 0 212 -212z" />
    <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M958 1633 l-108 -108 -58 58 -57 57 -88 -88 -87 -87 145 -145 145 -145 195 195 195 195 -88 88 -87 87 -107 -107z" />
    <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M1350 1450 l0 -130 200 0 200 0 0 130 0 130 -200 0 -200 0 0 -130z" />
    <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M958 933 l-108 -108 -58 58 -57 57 -88 -88 -87 -87 145 -145 145 -145 195 195 195 195 -88 88 -87 87 -107 -107z" />
    <path fill="currentColor" transform="translate(0 240) scale(.1 -.1)" d="M1350 750 l0 -130 200 0 200 0 0 130 0 130 -200 0 -200 0 0 -130z" />
  </>,
);
